export const ItemsCategoryColumns = [
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Descrption',
    accessor: 'description',
  },
  // {
  //     Header: 'Status',
  //     accessor: 'status',
  // },
  {
    Header: "Category",
    accessor: "department_Category",
  },
  {
    Header: 'Actions',
    accessor: 'actions',
  },
  {
    Header: 'Quick Actions',
    accessor: 'quick_actions',
  }
];
